var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-card"},[_c('div',{staticClass:"menu"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"30px"}},[_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p'),_c('span'),_c('p')])])])
}]

export { render, staticRenderFns }